import React from 'react';
import {useEffect} from 'react';
import Footer from './Footer';
import Header from './Header';
import {globalLinks, localLinks} from '@/lib//utils/constants';
import TCLogoMobile from '../../../../public/images/TCLogoMobile.svg';
import TCLogoDesktop from '../../../../public/images/TCLogoDesktop.svg';

export interface ModalProps {
  children: React.ReactNode;
}

const TCDecorator = ({children}: ModalProps) => {
  useEffect(() => {
    // TODO - is this required with the 'body-content' class in the outer div?
    const nextElement = document.querySelector('#__next');
    if (nextElement) {
      nextElement.className = 'body-content';
    }
  }, []);
  return (
    <div className="archive-icpsr body-content">
      <Header
        logoMobile={TCLogoMobile}
        logoDesktop={TCLogoDesktop}
        globalLinks={globalLinks}
        localLinks={localLinks}
        appName="TurboCurator"
        skipToID="skipto"
      />
      <div className="container">
        <div className="row justify-content-center">
          <div id="skipto" className="col-12 col-lg-10 col-xl-8">
            {children}
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default TCDecorator;
